import React from 'react';
import { View, StyleSheet, Text, StyleProp, ViewStyle } from 'react-native';
import { studentTheme } from '../../../theme/tokens';

interface TileNumberProps {
    value: number | string;
    theme?: 'green' | 'blue' | 'orange' | 'purple';
    size?: number;
    style?: StyleProp<ViewStyle>;
    testID?: string;
}

const themeBorder = {
    green: studentTheme.colors.candy.green,
    blue: studentTheme.colors.candy.blue,
    orange: studentTheme.colors.candy.orange,
    purple: studentTheme.colors.candy.purple,
};

/**
 * TileNumber — Boxed numeral card.
 * Matches the boxed [ 6 ] tile from the reference screenshot.
 */
export const TileNumber: React.FC<TileNumberProps> = ({
    value,
    theme = 'green',
    size = 52,
    style,
    testID = 'tile-number',
}) => {
    const borderColor = themeBorder[theme];

    return (
        <View
            testID={testID}
            style={[
                styles.tile,
                {
                    width: size,
                    height: size,
                    borderColor,
                    borderRadius: studentTheme.radii.tile,
                },
                style,
            ]}
        >
            <Text
                allowFontScaling={true}
                maxFontSizeMultiplier={1.4}
                style={[styles.number, { fontSize: Math.round(size * 0.58) }]}
            >
                {value}
            </Text>
        </View>
    );
};

const styles = StyleSheet.create({
    tile: {
        backgroundColor: '#FFFFFF',
        borderWidth: 2.5,
        alignItems: 'center',
        justifyContent: 'center',
        shadowColor: '#000000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 3,
        elevation: 2,
    },
    number: {
        fontWeight: '900',
        color: studentTheme.colors.text.dark,
    },
});
